import React from 'react'
import { connect } from 'react-redux'
import { Header, Form, Button, List, Image, Message, Segment } from 'semantic-ui-react'
import _ from 'lodash'
import { initializeDiagnosis, setDiagnosis, updatePayment,
    addImageToQueue, createQueue, submitDiagnosis } from '../redux/actions'

import { processPayment } from '../helpers/stripe_helper'

const environments = {
    prd: 'Production',
    dev: 'Development',
    test: 'Testing'
}

class Diagnosis extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showError: false,
            allowPayment: false,
            loadingPayment: false,
            paymentError: null
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleFiles = this.handleFiles.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        //this.renderDiagnosis = this.renderDiagnosis.bind(this)
    }

    handleChange(event) {
        event.persist()
        this.props.setDiagnosis(event.target.name, event.target.value)
    }

    handleFiles(event) {
        event.persist()
        if (!event.target.files[0]) {
            return
        }
        const arrFiles = Array.from(event.target.files)
        const value = arrFiles.map((file, index) => {
            const src = window.URL.createObjectURL(file)
            return { file, id: index, src }
        })
        const { newImages } = this.props.images
        const { currentIndex } = this.props.requestList
        if (!newImages[currentIndex]){
            this.props.createQueue({currentIndex})
        }
        this.props.addImageToQueue(value)
        //this.props.setDiagnosis(event.target.name, value)
    }

    async handleSubmit(event) {
        event.persist()
        const { requestArray, currentIndex } = this.props.requestList
        const { id, data } = requestArray[currentIndex]
        const { general, recommendations } = data.diagnosis
        
        if (general === '' || recommendations === '') {
            this.setState({ showError: true })
        } else {
            //console.log("submit diagnosis")
            const { newImages } = this.props.images
            let images = null
            if (newImages[currentIndex]){
                if (newImages[currentIndex].length > 0){
                    images = newImages[currentIndex]
                }
            }
            await this.props.submitDiagnosis({ id, general, recommendations, images })
            console.log("diagnosis submitted")
            this.setState({ showError: false })
            //this.reloadRequestList()
        }
        event.preventDefault()
    }

    async handlePayment(action, id, env) {
        try{
            //console.log("environment: ", env)
            this.setState({ 
                loadingPayment: true, 
                allowPayment: false, 
                paymentError: null 
            })
            // console.log("payment action: ", action)
            // console.log("payment id: ", id)
            
            const res = await processPayment({ id, action, env })
            //console.log("res: ", res)
            const data = await res.json()
            const response = JSON.parse(data.body)
            
            //console.log("payment response: ", response)

            if (response.error) {
                this.setState({ 
                    loadingPayment: false, 
                    paymentError: response.error 
                })
            } else {
                this.props.updatePayment(response.paymentIntent)
                this.setState({ 
                    loadingPayment: false, 
                    //paymentError: response.error 
                })
            }
        } catch (error) {
            console.log(error)
            this.setState({ 
                loadingPayment: false, 
                paymentError: error 
            })
        }
    }

    renderPaymentArea(data, env = null) {
        
        
        //console.log("payment intent: ", data)
        if (data === null){
            return (
                <div>
                <br />
                <Segment>
                    <h3>Payment Procesing</h3>
                    <p><strong>This was a free consultation!!</strong></p>
                </Segment>
                </div>
            )
        }
        const { id, status, amount, receipt_email } = data.paymentIntent
        const { loadingPayment, paymentError } = this.state

        let showError = null
        if ( paymentError !== null ){
            showError = 
                <Message negative>
                    <Message.Header>There was an error!</Message.Header>
                    <p>
                        {paymentError}
                    </p>
                </Message>
        }

        return (
            <div>
                <br />
                <Segment>
                    <h3>Payment Procesing</h3>
                    <br />
                    <p><strong>ID: </strong><span>{id}</span></p>
                    <p><strong>Environment: </strong><span>{environments[env]}</span></p>
                    <p><strong>Amount: </strong>$ <span>{amount/100}</span></p>
                    <p><strong>Receipt Email: </strong><span>{receipt_email}</span></p>
                    {/* <p><strong>Status: </strong><span>{status}</span></p> */}
                    <Message 
                        negative={status !== 'succeeded'? true: false} 
                        positive={status === 'succeeded'? true: false}
                    >
                        <Message.Header>Status</Message.Header>
                        <p>
                            {status}
                        </p>
                    </Message>
                    <br />
                    <List horizontal>
                        <Button 
                            primary
                            //disabled={!allowPayment}
                            onClick={() => this.handlePayment('capture', id, env)}
                            loading={loadingPayment}
                        >
                            Capture Payment
                        </Button>
                        <Button 
                            //disabled={!allowPayment}
                            onClick={() => this.handlePayment('cancel', id, env)}
                            loading={loadingPayment}
                        >
                            Cancel Payment
                        </Button>
                    </List>
                    <br />
                    {showError}
                </Segment>
            </div>
        )
    }
    
    render() {
        const { requestArray, currentIndex } = this.props.requestList
        const { data } = requestArray[currentIndex]
        const { diagnosis } = data
        //console.log("current request: ", data)
        if ( diagnosis === null ){
            this.props.initializeDiagnosis()
            return null
        }

        /////////////////////////////
        //// IMAGES

        let diagnosisSent = false
        if (_.has(diagnosis, 'sent')){
            if (diagnosis.sent) {
                diagnosisSent = true
            }
        }

        const { general, recommendations, images } = diagnosis
        const { showError } = this.state
        const { isUploading, newImages } = this.props.images

        let renderExistingImages = null
        if ( images ) {
            if (images.length > 0){

                renderExistingImages = 
                    <div>
                        Existing Images
                        <br />
                        <List horizontal relaxed style={{ marginTop: 10 }}>
                            {images.map((image, index) => {
                                return (
                                    <List.Item key={index}>
                                        <Image src={image.url} style={{ width: 100, resizeMode: 'contain' }} />
                                    </List.Item>

                                )
                            })}
                        </List>
                        <br />
                    </div>
            }    
        }

        let renderNewImages = null
        if ( newImages[currentIndex] ) {
            if (newImages[currentIndex].length > 0){
                renderNewImages = 
                    <div>
                        <br />
                        <List horizontal relaxed style={{ marginTop: 10 }}>
                            {newImages[currentIndex].map((image, index) => {
                                return (
                                    <List.Item key={index}>
                                        <Image src={image.src} style={{ width: 100, resizeMode: 'contain' }} />
                                    </List.Item>

                                )
                            })}
                        </List>
                        <br />
                    </div>
            }    
        }

        ///////////////////////////////

        ///////////////////////////////
        //// PAYMENT AREA

        let paymentArea = null
        let payment = null
        if (data.payment) {
            if (data.payment !== null) {
                if (_.has(data.payment, 'freeConsultation')){
                    paymentArea = this.renderPaymentArea(null)
                } else {
                    if (_.has(data.payment, 'env')){
                        payment = data.payment
                        paymentArea = this.renderPaymentArea(payment.data, payment.env)
                    }
                }
            }
        }

        //////////////////////////////

        const error =
            <Message negative>
                <Message.Header>Please fill in all required fields</Message.Header>
            </Message>
        const uploading =
            <Message>
                <Message.Header>Uploading Images ...</Message.Header>
            </Message>
        const sent =
            <Message positive>
                <Message.Header>Diagnosis Submitted</Message.Header>
            </Message>
        
        return (
            <div>
                <Header as='h2'>Diagnosis</Header>
                <Form onSubmit={this.handleSubmit}>
                    <Form.TextArea
                        name='general'
                        label='General Diagnosis (required)'
                        style={{ borderColor: showError && general === '' ? 'red' : null }}
                        placeholder='Enter Diagnosis Here...'
                        value={general}
                        onChange={this.handleChange}

                    />
                    <Form.TextArea
                        name='recommendations'
                        label='Recommendations (required)'
                        style={{ borderColor: showError && recommendations === '' ? 'red' : null }}
                        placeholder='Enter Recommendations Here...'
                        value={recommendations}
                        onChange={this.handleChange}
                    />
                    <Form.Field>

                        <label>Images</label>
                        <Segment>
                            {renderExistingImages}
                            <br /><br />
                            Add new images
                            <br /><br />
                            <input
                                id='images'
                                name='images'
                                type='file'
                                placeholder='Select the images to upload'
                                accept="image/x-png,image/gif,image/jpeg"
                                multiple
                                style={{ display: 'none' }}
                                onChange={this.handleFiles}
                            />
                            <label
                                htmlFor="images"
                                style={{
                                    display: 'inline-block',
                                    lineHeight: 2,
                                    padding: 1,
                                    backgroundColor: 'black'
                                }}
                            >
                                <span style={{ color: 'white', marginLeft: 5, marginRight: 5 }}>
                                    Select Images
                                </span>
                            </label>

                            <br />
                            {renderNewImages}
                        </Segment>
                    </Form.Field>
                    <br />
                    {showError ? error : null}
                    {isUploading ? uploading : null}
                    {diagnosisSent ? sent : null}
                    <Button
                        primary
                        type='submit'
                        style={{ marginTop: 20 }}
                        disabled={isUploading}
                        loading={isUploading}
                    >
                        Submit Diagnosis
                    </Button>
                    <br />
                </Form>
                {paymentArea}
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { requestList, images } = state
    return { requestList, images }
}

export default connect(mapStateToProps, { initializeDiagnosis, setDiagnosis, updatePayment,
    addImageToQueue, createQueue, submitDiagnosis })(Diagnosis)